import { useMutation } from '@tanstack/react-query';

import * as api from './api';
import type { ChatInput, SearchInput } from './types';

/** Single-shot chat call (server has no per-user history — we build it client-side). */
export function useAssistantChat() {
  return useMutation({
    mutationFn: (input: ChatInput) => api.chat(input),
  });
}

export function useAssistantSearch() {
  return useMutation({
    mutationFn: (input: SearchInput) => api.search(input),
  });
}
